import type { CapacityRange, TalosCapacityResponse, TalosResponse } from '@pulse/contracts';
import { useQuery } from '@tanstack/react-query';

import { apiRequest } from '@/lib/api-client';

/** The Talos page, as of now (TLS-1 to TLS-9). */
export function useTalos() {
  return useQuery({
    queryKey: ['pages', 'talos'],
    queryFn: () => apiRequest<TalosResponse>('/api/pages/talos'),
    staleTime: 60_000,
  });
}

/** Capacity on the Talos page over the last 24 hours or 7 days (TLS-10). */
export function useTalosCapacity(range: CapacityRange) {
  return useQuery({
    queryKey: ['pages', 'talos', 'capacity', range],
    queryFn: () => apiRequest<TalosCapacityResponse>(`/api/pages/talos/capacity?range=${range}`),
    staleTime: 60_000,
  });
}
